import { render, staticRenderFns } from "./bkxx.vue?vue&type=template&id=13bd74a3&scoped=true&"
import script from "./bkxx.vue?vue&type=script&lang=js&"
export * from "./bkxx.vue?vue&type=script&lang=js&"
import style0 from "./bkxx.vue?vue&type=style&index=0&id=13bd74a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bd74a3",
  null
  
)

export default component.exports